import type { SaveSearchMode } from "../../../types/saved-searches";

export const getTriggerTrackingNameBy = (saveMode: SaveSearchMode): string => {
    switch (saveMode) {
        case "onExport":
            return "export trigger";
        default:
            return "";
    }
};

export const getTriggerSaveActionTrackingNameBy = (saveMode: SaveSearchMode | undefined): string => {
    switch (saveMode) {
        case "onExport":
            return "save after export";
        default:
            return "";
    }
};

export const getTriggerCancelActionTrackingNameBy = (saveMode: SaveSearchMode | undefined): string => {
    switch (saveMode) {
        case "onExport":
            return "don't save after export";
        default:
            return "";
    }
};
